const initState = {
  userRoleId: 0,
  currentUserInfo: {},
  rootFolders: [],
  subFolders: {},
  notifications: [],
  // Request related
  isTemplateDrawerOpen: false,
  isMailingDrawerOpen: false,
};

// Request  Constant
export const TOGGLE_TEMPLATE_DRAWER = "TOGGLE_TEMPLATE_DRAWER";
export const TOGGLE_MAILING_DRAWER = "TOGGLE_MAILING_DRAWER";
// Request Actions
export const toggleTemplateDrawer = (isTemplateDrawerOpen) => {
  return {
    type: TOGGLE_TEMPLATE_DRAWER,
    isTemplateDrawerOpen,
  };
};

export const toggleMailingDrawer = (isMailingDrawerOpen) => {
  return {
    type: TOGGLE_MAILING_DRAWER,
    isMailingDrawerOpen,
  };
};

const UserDataReducer = (state = initState, action) => {
  if (action.type === "UPDATE_USER_ROLE") {
    return {
      ...state,
      userRoleId: action.roleId,
    };
  }
  if (action.type === "UPDATE_USER_INFO") {
    return {
      ...state,
      currentUserInfo: action.userInfo,
    };
  }
  if (action.type === "UPDATE_FOLDERS") {
    return {
      ...state,
      rootFolders: action.rootFolders,
      subFolders: action.subFolders,
    };
  }
  if (action.type === "UPDATE_NOTIFICATION") {
    return {
      ...state,
      notification: action.notifications,
    };
  }
  if (action.type === TOGGLE_TEMPLATE_DRAWER) {
    return {
      ...state,
      isTemplateDrawerOpen: action.isTemplateDrawerOpen,
    };
  }
  if (action.type === TOGGLE_MAILING_DRAWER) {
    return {
      ...state,
      isMailingDrawerOpen: action.isMailingDrawerOpen,
    };
  }
  return state;
};

export const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    updateUserRole: (roleId) => {
      dispatch({ type: "UPDATE_USER_ROLE", roleId: roleId });
    },
    updateCurrentUserInfo: (userInfo) => {
      dispatch({ type: "UPDATE_USER_INFO", userInfo: userInfo });
    },
    updateFolders: (foldersObj) => {
      dispatch({
        type: "UPDATE_FOLDERS",
        rootFolders: foldersObj.rootFolders,
        subFolders: foldersObj.subFolders,
      });
    },
    updateNotification: (notificationObj) => {
      dispatch({
        type: "UPDATE_NOTIFICATION",
        notifications: notificationObj.notifications,
      });
    },
  };
};

export default UserDataReducer;
